import css from 'styled-jsx/css';
import breakpoints from './breakpoints';

const gutter = '10px';

export default css.global`
  .row {
    display: flex;
    margin: 0 -${gutter};
    min-width: 0;
  }
  .row-top {
    align-items: flex-start;
  }
  .row-center {
    align-items: center;
  }
  .row-bottom {
    align-items: flex-end;
  }
  .row-stretch {
    align-items: stretch;
  }
  .row-reverse {
    flex-direction: row-reverse;
  }
  .row + .row,
  .row + .row-sm,
  .row + .row-md,
  .row + .row-lg,
  .row + .row-hg,
  .row-sm + .row,
  .row-sm + .row-sm,
  .row-sm + .row-md,
  .row-sm + .row-lg,
  .row-sm + .row-hg,
  .row-md + .row,
  .row-md + .row-sm,
  .row-md + .row-md,
  .row-md + .row-lg,
  .row-md + .row-hg,
  .row-lg + .row,
  .row-lg + .row-sm,
  .row-lg + .row-md,
  .row-lg + .row-lg,
  .row-lg + .row-hg,
  .row-hg + .row,
  .row-hg + .row-sm,
  .row-hg + .row-md,
  .row-hg + .row-lg,
  .row-hg + .row-hg {
    margin-top: calc(2 * ${gutter});
  }
  .row > .col,
  .row > .col-min,
  .row > .col-1of2,
  .row > .col-5of12,
  .row > .col-1of3,
  .row > .col-1of4,
  .row > .col-1of6,
  .row > .col-1of8,
  .row > .col-1of12 {
    margin: 0 ${gutter};
    min-width: 0;
  }

  .col {
    flex-grow: 1;
    flex-shrink: 1;
  }
  .col-min {
    flex-grow: 0;
    flex-shrink: 0;
  }
  .col-top {
    align-self: flex-start;
  }
  .col-center {
    align-self: center;
  }
  .col-bottom {
    align-self: flex-end;
  }
  .col-right {
    text-align: right;
  }
  .col-1of2 {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - (2 * ${gutter}));
  }
  .col-5of12 {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(41.66666667% - (2 * ${gutter}));
  }
  .col-1of3 {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(33.33333333% - (2 * ${gutter}));
  }
  .col-1of4 {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(25% - (2 * ${gutter}));
  }
  .col-1of6 {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(16.66666667% - (2 * ${gutter}));
  }
  .col-1of8 {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(12.5% - (2 * ${gutter}));
  }
  .col-1of12 {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(8.33333333% - (2 * ${gutter}));
  }

  @media (max-width: ${breakpoints.small - 1}px) {
    .row-sm > .col:not(:first-child),
    .row-sm > .col-min:not(:first-child):not(.col-no-top-margin),
    .row-sm > .col-1of2:not(:first-child):not(.col-no-top-margin),
    .row-sm > .col-5of12:not(:first-child):not(.col-no-top-margin),
    .row-sm > .col-1of3:not(:first-child):not(.col-no-top-margin),
    .row-sm > .col-1of4:not(:first-child):not(.col-no-top-margin),
    .row-sm > .col-1of6:not(:first-child):not(.col-no-top-margin),
    .row-sm > .col-1of8:not(:first-child):not(.col-no-top-margin),
    .row-sm > .col-1of12:not(:first-child):not(.col-no-top-margin) {
      margin-top: calc(2 * ${gutter});
    }
  }

  @media (min-width: ${breakpoints.small}px) {
    .row-sm {
      display: flex;
      margin: 0 -${gutter};
      min-width: 0;
    }
    .row-sm > .col,
    .row-sm > .col-min,
    .row-sm > .col-1of2,
    .row-sm > .col-5of12,
    .row-sm > .col-1of3,
    .row-sm > .col-1of4,
    .row-sm > .col-1of6,
    .row-sm > .col-1of8,
    .row-sm > .col-1of12 {
      margin: 0 ${gutter};
      min-width: 0;
    }
  }

  @media (max-width: ${breakpoints.medium - 1}px) {
    .row-md > .col:not(:first-child):not(.col-no-top-margin),
    .row-md > .col-min:not(:first-child):not(.col-no-top-margin),
    .row-md > .col-1of2:not(:first-child):not(.col-no-top-margin),
    .row-md > .col-5of12:not(:first-child):not(.col-no-top-margin),
    .row-md > .col-1of3:not(:first-child):not(.col-no-top-margin),
    .row-md > .col-1of4:not(:first-child):not(.col-no-top-margin),
    .row-md > .col-1of6:not(:first-child):not(.col-no-top-margin),
    .row-md > .col-1of8:not(:first-child):not(.col-no-top-margin),
    .row-md > .col-1of12:not(:first-child):not(.col-no-top-margin) {
      margin-top: calc(2 * ${gutter});
    }
  }

  @media (min-width: ${breakpoints.medium}px) {
    .row-md {
      display: flex;
      margin: 0 -${gutter};
      min-width: 0;
    }
    .row-md > .col,
    .row-md > .col-min,
    .row-md > .col-1of2,
    .row-md > .col-5of12,
    .row-md > .col-1of3,
    .row-md > .col-1of4,
    .row-md > .col-1of6,
    .row-md > .col-1of8,
    .row-md > .col-1of12 {
      margin: 0 ${gutter};
      min-width: 0;
    }
  }

  @media (max-width: ${breakpoints.large - 1}px) {
    .row-lg > .col:not(:first-child):not(.col-no-top-margin),
    .row-lg > .col-min:not(:first-child):not(.col-no-top-margin),
    .row-lg > .col-1of2:not(:first-child):not(.col-no-top-margin),
    .row-lg > .col-5of12:not(:first-child):not(.col-no-top-margin),
    .row-lg > .col-1of3:not(:first-child):not(.col-no-top-margin),
    .row-lg > .col-1of4:not(:first-child):not(.col-no-top-margin),
    .row-lg > .col-1of6:not(:first-child):not(.col-no-top-margin),
    .row-lg > .col-1of8:not(:first-child):not(.col-no-top-margin),
    .row-lg > .col-1of12:not(:first-child):not(.col-no-top-margin) {
      margin-top: calc(2 * ${gutter});
    }
  }

  @media (min-width: ${breakpoints.large}px) {
    .row-lg {
      display: flex;
      margin: 0 -${gutter};
      min-width: 0;
    }
    .row-lg > .col,
    .row-lg > .col-min,
    .row-lg > .col-1of2,
    .row-lg > .col-5of12,
    .row-lg > .col-1of3,
    .row-lg > .col-1of4,
    .row-lg > .col-1of6,
    .row-lg > .col-1of8,
    .row-lg > .col-1of12 {
      margin: 0 ${gutter};
      min-width: 0;
    }
  }

  @media (max-width: ${breakpoints.huge - 1}px) {
    .row-hg > .col:not(:first-child):not(.col-no-top-margin),
    .row-hg > .col-min:not(:first-child):not(.col-no-top-margin),
    .row-hg > .col-1of2:not(:first-child):not(.col-no-top-margin),
    .row-hg > .col-5of12:not(:first-child):not(.col-no-top-margin),
    .row-hg > .col-1of3:not(:first-child):not(.col-no-top-margin),
    .row-hg > .col-1of4:not(:first-child):not(.col-no-top-margin),
    .row-hg > .col-1of6:not(:first-child):not(.col-no-top-margin),
    .row-hg > .col-1of8:not(:first-child):not(.col-no-top-margin),
    .row-hg > .col-1of12:not(:first-child):not(.col-no-top-margin) {
      margin-top: calc(2 * ${gutter});
    }
  }

  @media (min-width: ${breakpoints.huge}px) {
    .row-hg {
      display: flex;
      margin: 0 -${gutter};
      min-width: 0;
    }
    .row-hg > .col,
    .row-hg > .col-min,
    .row-hg > .col-1of2,
    .row-hg > .col-5of12,
    .row-hg > .col-1of3,
    .row-hg > .col-1of4,
    .row-hg > .col-1of6,
    .row-hg > .col-1of8,
    .row-hg > .col-1of12 {
      margin: 0 ${gutter};
      min-width: 0;
    }
  }
`;
